/**
 * Sticky-header condense-on-scroll.
 *
 * Adds `.is-scrolled` to #site-header once the page is scrolled past a small
 * threshold, and removes it at the top. The CSS uses that class to collapse
 * the top utility bar and shrink the logo, so the full header shows at the
 * top of the page and a compact one shows while scrolling.
 */
export function initStickyHeader() {
	const header = document.getElementById('site-header');
	if (!header) return;

	const THRESHOLD = 24; // px scrolled before condensing
	let ticking = false;

	function update() {
		header.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
		ticking = false;
	}

	window.addEventListener('scroll', () => {
		if (!ticking) {
			window.requestAnimationFrame(update);
			ticking = true;
		}
	}, { passive: true });

	update(); // set correct state on load (e.g. when reloaded mid-page)
}
